import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetNotificationQuery } from '../../services/connectApi';
import NotificationDetails from './NotificationDetails';

const NotificationDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data: notification, isLoading } = useGetNotificationQuery(id as string);

  if (isLoading) {
    return null;
  }

  if (!notification) {
    return null;
  }

  return (
    <NotificationDetails
      open={true}
      notification={notification}
      onClose={() => navigate('/connect')}
    />
  );
};

export default NotificationDetailsPage;